// import Multiselect from 'vue-multiselect';

module.exports = {
    props: ['user', 'teams'],
    // components: {Multiselect},


    /**
     * The component's data.
     */
    data() {
        return {
            company_cam_client_id:'2WgR0WGtqcslmmjzBmVYW-nCqUuvyzjld0oVSBIzxLg',
            sandbox_procore_client_id:'bee97d10204dc4aa58516e95a677326f1c17ed43e5affc4f57730759a4aa6ba2',
            live_procore_client_id:'674c3dc85d9f53b02cca1fe342d4e8f3de5676066a022a23dfbe80b654fd0902',
            hoverUserEmail: null,
            xScopeToken: null,
            selectedProcoreCompany: null,
            procoreCompanies: [],
        };
    },
    computed: {
		urlForHoverDisconnect() {
			return '/hover/disconnect';
		},
        urlForHoverSaveEmail() {
			return '/hover/save-user-email';
		},
        urlForNylasDisconnect() {
			return '/disconnect-nylas';
		},
        urlForSaveXScopeToken() {
			return '/xscope/save-token';
		},
	},
    mounted() {
        this.hoverUserEmail = this.user.hover_user_email;
        this.xScopeToken = this.user.xscope_token;
        if(this.user.procore_partner_response_code !== null){
            if (this.user.procore_partner_companies !== null){
                this.selectedProcoreCompany = this.user.procore_partner_selected_company;
                this.procoreCompanies = JSON.parse(this.user.procore_partner_companies);
            }else {
                this.fetchProcoreCompanies();
            }
        }
    },
    methods: {
        /**
         * Connect to stack.
         */
        connectToStack(){
            let url = ''
            if(window.location.origin == 'https://app.followupcrm.com'){
                url = 'https://go.stackct.com/OAuth/Authorize?client_id=23&redirect_uri='+window.location.origin+'/get-stack-code&state=partner-created-value&response_type=code';
            }else{
                url = 'https://c3.ct-test.net/OAuth/Authorize?client_id=29&redirect_uri='+window.location.origin+'/get-stack-code&state=partner-created-value&response_type=code';
            }

            window.open(url, '_blank').focus();
        },

        /**
         * Connect to Company Cam.
         */
        connectToCompanyCam(){
            let url = '';
            if(window.location.origin == 'https://app.followupcrm.com'){
                url = 'https://app.companycam.com/oauth/authorize?client_id='+this.company_cam_client_id+'&redirect_uri=https://app.followupcrm.com/get-company-cam-code&response_type=code&scope=read+write+destroy'
            }else{
                url = 'https://app.companycam.com/oauth/authorize?client_id='+this.company_cam_client_id+'&redirect_uri=https://stage.followupcrm.com/get-company-cam-code&response_type=code&scope=read+write+destroy'
            }

            window.open(url, '_blank').focus();
        },
        /**
         * Connect to Procore.
         */
        connectToProcore(){
            let url = '';
            if(window.location.origin == 'https://app.followupcrm.com'){
                url = 'https://login.procore.com/oauth/authorize?response_type=code&client_id='+this.live_procore_client_id+'&redirect_uri='+window.location.origin+'/get-procore-code'
            }else{
                url = 'https://login-sandbox.procore.com/oauth/authorize?response_type=code&client_id='+this.sandbox_procore_client_id+'&redirect_uri='+window.location.origin+'/get-procore-code'
            }
            window.open(url, '_blank').focus();
        },
        /**
         * Connect to Hover.
         */
        connectToHover(){
            let url = process.env.MIX_HOVER_URL+'/oauth/authorize?client_id='+process.env.MIX_HOVER_CLIENT_ID+'&response_type=code&redirect_uri='+process.env.MIX_HOVER_REDIRECT_URI
            window.open(url, '_blank').focus();
        },
        saveUserEmail() {
            if(this.hoverUserEmail && this.validEmail(this.hoverUserEmail)) {
                axios.post(this.urlForHoverSaveEmail, {email: this.hoverUserEmail})
                    .then(response => {
                        window.location.reload();
                    });
            }
            else {
                this.getToast(4000).fire({
                    type: 'error',
                    title: 'Please enter valid email address!'
                });
            }
        },
        disconnectHover(){
            axios.get(this.urlForHoverDisconnect)
				.then(response => {
					window.location.reload();
				});
        },
        /**
         * Connect to Nylas.
         */
         connectToNylas(){
            let url = process.env.MIX_NYLAS_URL+'oauth/authorize?client_id='+process.env.MIX_NYLAS_CLIENT_ID+'&response_type=code&login_hint=dev@followupcrm.com&redirect_uri='+process.env.MIX_NYLAS_REDIRECT_URI+'&state=mycustomstate&scopes=email,contacts'
            window.open(url, '_blank').focus();

        },
        disconnectNylas(){
            axios.get('')
				.then(response => {
					window.location.reload();
				});
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        /**
         * XScope
         */
        saveXScopeToken() {
            axios.post(this.urlForSaveXScopeToken, {token: this.xScopeToken})
                .then(response => {
                    window.location.reload();
                }).
                catch(error => {
                    this.getToast(4000).fire({
                        type: 'error',
                        title: 'Some error occurred!'
                    });
                });
        },

        /**
         * Fetch procore companies
         */
        fetchProcoreCompanies(){
            axios.get('/procore/fetch-companies')
                .then(response => {
                    this.procoreCompanies = JSON.parse(response.data.companies);
                });
        },
        /**
         * Select Company POP UP for procore
         */
        addProcoreCompany(){
            $('#procoreCompaniesModal').modal('show');
        },

        /**
         * Add Company for procore
         */
        saveProcoreCompany() {
            if (this.selectedProcoreCompany == null){
                this.getToast(4000).fire({
                    type: 'error',
                    title: 'Please select company!'
                });
                return;
            }
            axios.post('/procore/save-company-id', {select_company_id: this.selectedProcoreCompany})
                .then(response => {
                    window.location.reload();
                }).
            catch(error => {
                this.getToast(4000).fire({
                    type: 'error',
                    title: 'Some error occurred!'
                });
            });
        },
    }
};
